import script from "./ClientDocumentSignFlow.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientDocumentSignFlow.vue?vue&type=script&setup=true&lang=js"

import "./ClientDocumentSignFlow.vue?vue&type=style&index=0&id=0df923e9&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0df923e9"]])

export default __exports__